export default "__VITE_ASSET__CnMQKpvk__"